import { BASE_PATH as k, BaseAPI as w, operationServerMap as v } from "../base.js";
import { DUMMY_BASE_URL as S, assertParamExists as G, createRequestFunction as p, serializeDataIfNeeded as y, setSearchParams as W, toPathString as O } from "../common.js";
import u from "axios";
var P = function(r) {
  return {
    merchantWmsStockAddCheck: async (a, c, s = {}) => {
      G("merchantWmsStockAddCheck", "shopId", a), G("merchantWmsStockAddCheck", "merchantWmsStockCheckRecordVO", c);
      const t = new URL("/merchant/wms/stock/addCheck", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "POST",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.shopId = a), l["Content-Type"] = "application/json", W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, o.data = y(c, o, r), {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockAddCheckV2: async (a, c = {}) => {
      G("merchantWmsStockAddCheckV2", "merchantWmsStockCheckRecordVO", a);
      const s = new URL("/merchant/wms/stock/addCheck/v2", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...c
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, e.data = y(a, e, r), {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockCreateStockIn: async (a, c = {}) => {
      G("merchantWmsStockCreateStockIn", "merchantWmsStockInventoryVO", a);
      const s = new URL("/merchant/wms/stock/inventory/v2", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...c
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, e.data = y(a, e, r), {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockDeApprove: async (a, c = {}) => {
      G("merchantWmsStockDeApprove", "wmsDeApproveDTO", a);
      const s = new URL("/merchant/wms/stock/deApprove", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...c
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, e.data = y(a, e, r), {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockDeApproveCheckOrder: async (a, c = {}) => {
      G("merchantWmsStockDeApproveCheckOrder", "checkRecordId", a);
      const s = new URL("/merchant/wms/stock/check/deApprove", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...c
      }, o = {}, l = {};
      a !== void 0 && (l.checkRecordId = a), W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockGetCategoryStockOverview: async (a, c, s = {}) => {
      const t = new URL("/merchant/wms/stock/category/overview", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.startTime = a), c !== void 0 && (n.endTime = c), W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetCheckRecordDetail: async (a, c = {}) => {
      G("merchantWmsStockGetCheckRecordDetail", "checkRecordId", a);
      const s = "/merchant/wms/stock/checkRecord/detail/{checkRecordId}".replace("{checkRecordId}", encodeURIComponent(String(a))), t = new URL(s, S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...c
      }, l = {};
      W(t, {});
      let n = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...n,
        ...c.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetCheckRecordProfitAndLoss: async (a, c = {}) => {
      G("merchantWmsStockGetCheckRecordProfitAndLoss", "command", a);
      const s = new URL("/merchant/wms/stock/checkRecord/profitAndLoss", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...c
      }, o = {}, l = {};
      if (a !== void 0) for (const [h, m] of Object.entries(a)) l[h] = m;
      W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockGetCheckRecordProfitAndLossSummary: async (a, c = {}) => {
      G("merchantWmsStockGetCheckRecordProfitAndLossSummary", "command", a);
      const s = new URL("/merchant/wms/stock/checkRecord/profitAndLoss/summary", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...c
      }, o = {}, l = {};
      if (a !== void 0) for (const [h, m] of Object.entries(a)) l[h] = m;
      W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockGetEffectiveTime: async (a = {}) => {
      const c = new URL("/merchant/wms/stock/deApproveEffectiveTime", S);
      let s;
      r && (s = r.baseOptions);
      const t = {
        method: "GET",
        ...s,
        ...a
      }, e = {};
      W(c, {});
      let o = s && s.headers ? s.headers : {};
      return t.headers = {
        ...e,
        ...o,
        ...a.headers
      }, {
        url: O(c),
        options: t
      };
    },
    merchantWmsStockGetInStockOverview: async (a, c, s = {}) => {
      const t = new URL("/merchant/wms/stock/inStock/overview", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.startTime = a), c !== void 0 && (n.endTime = c), W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetInventoryRecord: async (a, c, s, t, e, o, l, n = {}) => {
      G("merchantWmsStockGetInventoryRecord", "shopId", a);
      const h = new URL("/merchant/wms/stock/inventory", S);
      let m;
      r && (m = r.baseOptions);
      const d = {
        method: "GET",
        ...m,
        ...n
      }, I = {}, V = {};
      a !== void 0 && (V.shopId = a), c !== void 0 && (V.inventoryRecordId = c), s && (V.inventoryType = s), t !== void 0 && (V.startTime = t), e !== void 0 && (V.endTime = e), o !== void 0 && (V.current = o), l !== void 0 && (V.size = l), W(h, V);
      let R = m && m.headers ? m.headers : {};
      return d.headers = {
        ...I,
        ...R,
        ...n.headers
      }, {
        url: O(h),
        options: d
      };
    },
    merchantWmsStockGetInventoryRecordDetail: async (a, c = {}) => {
      G("merchantWmsStockGetInventoryRecordDetail", "inventoryRecordId", a);
      const s = "/merchant/wms/stock/inventory/detail/{inventoryRecordId}".replace("{inventoryRecordId}", encodeURIComponent(String(a))), t = new URL(s, S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...c
      }, l = {};
      W(t, {});
      let n = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...n,
        ...c.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetInventoryRecordList: async (a, c = {}) => {
      G("merchantWmsStockGetInventoryRecordList", "query", a);
      const s = new URL("/merchant/wms/stock/v2/inventory/list", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...c
      }, o = {}, l = {};
      if (a !== void 0) for (const [h, m] of Object.entries(a)) l[h] = m;
      W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockGetLastStockInPrice: async (a, c = {}) => {
      G("merchantWmsStockGetLastStockInPrice", "skuId", a);
      const s = new URL("/merchant/wms/stock/lastStockInPrice", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...c
      }, o = {}, l = {};
      a && (l.skuId = a), W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockGetOutStockOverview: async (a, c, s = {}) => {
      const t = new URL("/merchant/wms/stock/outStock/overview", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.startTime = a), c !== void 0 && (n.endTime = c), W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetPreviousSkuInfo: async (a, c, s = {}) => {
      G("merchantWmsStockGetPreviousSkuInfo", "recordId", a), G("merchantWmsStockGetPreviousSkuInfo", "skuId", c);
      const t = new URL("/merchant/wms/stock/previous/sku", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.recordId = a), c && (n.skuId = c), W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetStockCheckRecordList: async (a, c = {}) => {
      G("merchantWmsStockGetStockCheckRecordList", "query", a);
      const s = new URL("/merchant/wms/stock/v2/checkRecord", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...c
      }, o = {}, l = {};
      if (a !== void 0) for (const [h, m] of Object.entries(a)) l[h] = m;
      W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, {
        url: O(s),
        options: e
      };
    },
    merchantWmsStockGetStockCheckRecords: async (a, c, s, t, e, o, l, n = {}) => {
      G("merchantWmsStockGetStockCheckRecords", "shopId", a);
      const h = new URL("/merchant/wms/stock/checkRecord", S);
      let m;
      r && (m = r.baseOptions);
      const d = {
        method: "GET",
        ...m,
        ...n
      }, I = {}, V = {};
      a !== void 0 && (V.shopId = a), c !== void 0 && (V.current = c), s !== void 0 && (V.size = s), t !== void 0 && (V.startTime = t), e !== void 0 && (V.endTime = e), o !== void 0 && (V.checkStatus = o), l !== void 0 && (V.checkResult = l), W(h, V);
      let R = m && m.headers ? m.headers : {};
      return d.headers = {
        ...I,
        ...R,
        ...n.headers
      }, {
        url: O(h),
        options: d
      };
    },
    merchantWmsStockGetStockOverview: async (a, c, s = {}) => {
      const t = new URL("/merchant/wms/stock/overview", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.startTime = a), c !== void 0 && (n.endTime = c), W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockGetStockStatistics: async (a = {}) => {
      const c = new URL("/merchant/wms/stock/getStockStatistics", S);
      let s;
      r && (s = r.baseOptions);
      const t = {
        method: "GET",
        ...s,
        ...a
      }, e = {};
      W(c, {});
      let o = s && s.headers ? s.headers : {};
      return t.headers = {
        ...e,
        ...o,
        ...a.headers
      }, {
        url: O(c),
        options: t
      };
    },
    merchantWmsStockStockIn: async (a, c, s = {}) => {
      G("merchantWmsStockStockIn", "shopId", a), G("merchantWmsStockStockIn", "merchantWmsStockInventoryVO", c);
      const t = new URL("/merchant/wms/stock/inventory", S);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "POST",
        ...e,
        ...s
      }, l = {}, n = {};
      a !== void 0 && (n.shopId = a), l["Content-Type"] = "application/json", W(t, n);
      let h = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...h,
        ...s.headers
      }, o.data = y(c, o, r), {
        url: O(t),
        options: o
      };
    },
    merchantWmsStockUpdateCheck: async (a, c = {}) => {
      G("merchantWmsStockUpdateCheck", "merchantWmsStockCheckRecordVO", a);
      const s = new URL("/merchant/wms/stock/updateCheck", S);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...c
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", W(s, l);
      let n = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...n,
        ...c.headers
      }, e.data = y(a, e, r), {
        url: O(s),
        options: e
      };
    }
  };
}, i = function(r) {
  const a = P(r);
  return {
    async merchantWmsStockAddCheck(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockAddCheck(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockAddCheck"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockAddCheckV2(c, s) {
      var t, e;
      const o = await a.merchantWmsStockAddCheckV2(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockAddCheckV2"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockCreateStockIn(c, s) {
      var t, e;
      const o = await a.merchantWmsStockCreateStockIn(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockCreateStockIn"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockDeApprove(c, s) {
      var t, e;
      const o = await a.merchantWmsStockDeApprove(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockDeApprove"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockDeApproveCheckOrder(c, s) {
      var t, e;
      const o = await a.merchantWmsStockDeApproveCheckOrder(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockDeApproveCheckOrder"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetCategoryStockOverview(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockGetCategoryStockOverview(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockGetCategoryStockOverview"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockGetCheckRecordDetail(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetCheckRecordDetail(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetCheckRecordDetail"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetCheckRecordProfitAndLoss(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetCheckRecordProfitAndLoss(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetCheckRecordProfitAndLoss"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetCheckRecordProfitAndLossSummary(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetCheckRecordProfitAndLossSummary(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetCheckRecordProfitAndLossSummary"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetEffectiveTime(c) {
      var s, t;
      const e = await a.merchantWmsStockGetEffectiveTime(c), o = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, l = (t = v["MerchantWmsStockApi.merchantWmsStockGetEffectiveTime"]) === null || t === void 0 || (t = t[o]) === null || t === void 0 ? void 0 : t.url;
      return (n, h) => p(e, u, k, r)(n, l || h);
    },
    async merchantWmsStockGetInStockOverview(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockGetInStockOverview(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockGetInStockOverview"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockGetInventoryRecord(c, s, t, e, o, l, n, h) {
      var m, d;
      const I = await a.merchantWmsStockGetInventoryRecord(c, s, t, e, o, l, n, h), V = (m = r == null ? void 0 : r.serverIndex) !== null && m !== void 0 ? m : 0, R = (d = v["MerchantWmsStockApi.merchantWmsStockGetInventoryRecord"]) === null || d === void 0 || (d = d[V]) === null || d === void 0 ? void 0 : d.url;
      return (A, C) => p(I, u, k, r)(A, R || C);
    },
    async merchantWmsStockGetInventoryRecordDetail(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetInventoryRecordDetail(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetInventoryRecordDetail"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetInventoryRecordList(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetInventoryRecordList(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetInventoryRecordList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetLastStockInPrice(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetLastStockInPrice(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetLastStockInPrice"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetOutStockOverview(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockGetOutStockOverview(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockGetOutStockOverview"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockGetPreviousSkuInfo(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockGetPreviousSkuInfo(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockGetPreviousSkuInfo"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockGetStockCheckRecordList(c, s) {
      var t, e;
      const o = await a.merchantWmsStockGetStockCheckRecordList(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockGetStockCheckRecordList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    },
    async merchantWmsStockGetStockCheckRecords(c, s, t, e, o, l, n, h) {
      var m, d;
      const I = await a.merchantWmsStockGetStockCheckRecords(c, s, t, e, o, l, n, h), V = (m = r == null ? void 0 : r.serverIndex) !== null && m !== void 0 ? m : 0, R = (d = v["MerchantWmsStockApi.merchantWmsStockGetStockCheckRecords"]) === null || d === void 0 || (d = d[V]) === null || d === void 0 ? void 0 : d.url;
      return (A, C) => p(I, u, k, r)(A, R || C);
    },
    async merchantWmsStockGetStockOverview(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockGetStockOverview(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockGetStockOverview"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockGetStockStatistics(c) {
      var s, t;
      const e = await a.merchantWmsStockGetStockStatistics(c), o = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, l = (t = v["MerchantWmsStockApi.merchantWmsStockGetStockStatistics"]) === null || t === void 0 || (t = t[o]) === null || t === void 0 ? void 0 : t.url;
      return (n, h) => p(e, u, k, r)(n, l || h);
    },
    async merchantWmsStockStockIn(c, s, t) {
      var e, o;
      const l = await a.merchantWmsStockStockIn(c, s, t), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, h = (o = v["MerchantWmsStockApi.merchantWmsStockStockIn"]) === null || o === void 0 || (o = o[n]) === null || o === void 0 ? void 0 : o.url;
      return (m, d) => p(l, u, k, r)(m, h || d);
    },
    async merchantWmsStockUpdateCheck(c, s) {
      var t, e;
      const o = await a.merchantWmsStockUpdateCheck(c, s), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (e = v["MerchantWmsStockApi.merchantWmsStockUpdateCheck"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (h, m) => p(o, u, k, r)(h, n || m);
    }
  };
}, L = function(r, a, c) {
  const s = i(r);
  return {
    merchantWmsStockAddCheck(t, e) {
      return s.merchantWmsStockAddCheck(t.shopId, t.merchantWmsStockCheckRecordVO, e).then((o) => o(c, a));
    },
    merchantWmsStockAddCheckV2(t, e) {
      return s.merchantWmsStockAddCheckV2(t.merchantWmsStockCheckRecordVO, e).then((o) => o(c, a));
    },
    merchantWmsStockCreateStockIn(t, e) {
      return s.merchantWmsStockCreateStockIn(t.merchantWmsStockInventoryVO, e).then((o) => o(c, a));
    },
    merchantWmsStockDeApprove(t, e) {
      return s.merchantWmsStockDeApprove(t.wmsDeApproveDTO, e).then((o) => o(c, a));
    },
    merchantWmsStockDeApproveCheckOrder(t, e) {
      return s.merchantWmsStockDeApproveCheckOrder(t.checkRecordId, e).then((o) => o(c, a));
    },
    merchantWmsStockGetCategoryStockOverview(t = {}, e) {
      return s.merchantWmsStockGetCategoryStockOverview(t.startTime, t.endTime, e).then((o) => o(c, a));
    },
    merchantWmsStockGetCheckRecordDetail(t, e) {
      return s.merchantWmsStockGetCheckRecordDetail(t.checkRecordId, e).then((o) => o(c, a));
    },
    merchantWmsStockGetCheckRecordProfitAndLoss(t, e) {
      return s.merchantWmsStockGetCheckRecordProfitAndLoss(t.command, e).then((o) => o(c, a));
    },
    merchantWmsStockGetCheckRecordProfitAndLossSummary(t, e) {
      return s.merchantWmsStockGetCheckRecordProfitAndLossSummary(t.command, e).then((o) => o(c, a));
    },
    merchantWmsStockGetEffectiveTime(t) {
      return s.merchantWmsStockGetEffectiveTime(t).then((e) => e(c, a));
    },
    merchantWmsStockGetInStockOverview(t = {}, e) {
      return s.merchantWmsStockGetInStockOverview(t.startTime, t.endTime, e).then((o) => o(c, a));
    },
    merchantWmsStockGetInventoryRecord(t, e) {
      return s.merchantWmsStockGetInventoryRecord(t.shopId, t.inventoryRecordId, t.inventoryType, t.startTime, t.endTime, t.current, t.size, e).then((o) => o(c, a));
    },
    merchantWmsStockGetInventoryRecordDetail(t, e) {
      return s.merchantWmsStockGetInventoryRecordDetail(t.inventoryRecordId, e).then((o) => o(c, a));
    },
    merchantWmsStockGetInventoryRecordList(t, e) {
      return s.merchantWmsStockGetInventoryRecordList(t.query, e).then((o) => o(c, a));
    },
    merchantWmsStockGetLastStockInPrice(t, e) {
      return s.merchantWmsStockGetLastStockInPrice(t.skuId, e).then((o) => o(c, a));
    },
    merchantWmsStockGetOutStockOverview(t = {}, e) {
      return s.merchantWmsStockGetOutStockOverview(t.startTime, t.endTime, e).then((o) => o(c, a));
    },
    merchantWmsStockGetPreviousSkuInfo(t, e) {
      return s.merchantWmsStockGetPreviousSkuInfo(t.recordId, t.skuId, e).then((o) => o(c, a));
    },
    merchantWmsStockGetStockCheckRecordList(t, e) {
      return s.merchantWmsStockGetStockCheckRecordList(t.query, e).then((o) => o(c, a));
    },
    merchantWmsStockGetStockCheckRecords(t, e) {
      return s.merchantWmsStockGetStockCheckRecords(t.shopId, t.current, t.size, t.startTime, t.endTime, t.checkStatus, t.checkResult, e).then((o) => o(c, a));
    },
    merchantWmsStockGetStockOverview(t = {}, e) {
      return s.merchantWmsStockGetStockOverview(t.startTime, t.endTime, e).then((o) => o(c, a));
    },
    merchantWmsStockGetStockStatistics(t) {
      return s.merchantWmsStockGetStockStatistics(t).then((e) => e(c, a));
    },
    merchantWmsStockStockIn(t, e) {
      return s.merchantWmsStockStockIn(t.shopId, t.merchantWmsStockInventoryVO, e).then((o) => o(c, a));
    },
    merchantWmsStockUpdateCheck(t, e) {
      return s.merchantWmsStockUpdateCheck(t.merchantWmsStockCheckRecordVO, e).then((o) => o(c, a));
    }
  };
}, T = class extends w {
  merchantWmsStockAddCheck(r, a) {
    return i(this.configuration).merchantWmsStockAddCheck(r.shopId, r.merchantWmsStockCheckRecordVO, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockAddCheckV2(r, a) {
    return i(this.configuration).merchantWmsStockAddCheckV2(r.merchantWmsStockCheckRecordVO, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockCreateStockIn(r, a) {
    return i(this.configuration).merchantWmsStockCreateStockIn(r.merchantWmsStockInventoryVO, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockDeApprove(r, a) {
    return i(this.configuration).merchantWmsStockDeApprove(r.wmsDeApproveDTO, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockDeApproveCheckOrder(r, a) {
    return i(this.configuration).merchantWmsStockDeApproveCheckOrder(r.checkRecordId, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetCategoryStockOverview(r = {}, a) {
    return i(this.configuration).merchantWmsStockGetCategoryStockOverview(r.startTime, r.endTime, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetCheckRecordDetail(r, a) {
    return i(this.configuration).merchantWmsStockGetCheckRecordDetail(r.checkRecordId, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetCheckRecordProfitAndLoss(r, a) {
    return i(this.configuration).merchantWmsStockGetCheckRecordProfitAndLoss(r.command, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetCheckRecordProfitAndLossSummary(r, a) {
    return i(this.configuration).merchantWmsStockGetCheckRecordProfitAndLossSummary(r.command, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetEffectiveTime(r) {
    return i(this.configuration).merchantWmsStockGetEffectiveTime(r).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsStockGetInStockOverview(r = {}, a) {
    return i(this.configuration).merchantWmsStockGetInStockOverview(r.startTime, r.endTime, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetInventoryRecord(r, a) {
    return i(this.configuration).merchantWmsStockGetInventoryRecord(r.shopId, r.inventoryRecordId, r.inventoryType, r.startTime, r.endTime, r.current, r.size, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetInventoryRecordDetail(r, a) {
    return i(this.configuration).merchantWmsStockGetInventoryRecordDetail(r.inventoryRecordId, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetInventoryRecordList(r, a) {
    return i(this.configuration).merchantWmsStockGetInventoryRecordList(r.query, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetLastStockInPrice(r, a) {
    return i(this.configuration).merchantWmsStockGetLastStockInPrice(r.skuId, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetOutStockOverview(r = {}, a) {
    return i(this.configuration).merchantWmsStockGetOutStockOverview(r.startTime, r.endTime, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetPreviousSkuInfo(r, a) {
    return i(this.configuration).merchantWmsStockGetPreviousSkuInfo(r.recordId, r.skuId, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetStockCheckRecordList(r, a) {
    return i(this.configuration).merchantWmsStockGetStockCheckRecordList(r.query, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetStockCheckRecords(r, a) {
    return i(this.configuration).merchantWmsStockGetStockCheckRecords(r.shopId, r.current, r.size, r.startTime, r.endTime, r.checkStatus, r.checkResult, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetStockOverview(r = {}, a) {
    return i(this.configuration).merchantWmsStockGetStockOverview(r.startTime, r.endTime, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockGetStockStatistics(r) {
    return i(this.configuration).merchantWmsStockGetStockStatistics(r).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsStockStockIn(r, a) {
    return i(this.configuration).merchantWmsStockStockIn(r.shopId, r.merchantWmsStockInventoryVO, a).then((c) => c(this.axios, this.basePath));
  }
  merchantWmsStockUpdateCheck(r, a) {
    return i(this.configuration).merchantWmsStockUpdateCheck(r.merchantWmsStockCheckRecordVO, a).then((c) => c(this.axios, this.basePath));
  }
};
export {
  T as MerchantWmsStockApi,
  P as MerchantWmsStockApiAxiosParamCreator,
  L as MerchantWmsStockApiFactory,
  i as MerchantWmsStockApiFp
};

//# sourceMappingURL=merchant-wms-stock-api.js.map